export const OPEN_LAYER = 'OPEN_LAYER';

export const CLOSE_LAYER = 'CLOSE_LAYER';

export const RESIZE = 'resize';

/**
 * 实时同步锁定
 */
export const REALTIME_SYNC_LOCKED = 'realtimeSyncLocked';
/**
 * 实时同步解锁
 */
export const REALTIME_SYNC_UNLOCKED = 'realtimeSyncUnlocked';
/** 
 * 接受到消息
 */
export const RECEIVED_MESSAGE = 'receivedMessage';


/**
 *  同步屏幕 
 */
export const SYNC_SCREEN = 'syncScreen'; 